import React from 'react'

export default function Header() {
  return (
    <div className="header">
      <h1 className="header__heading">Tic <span className="header__heading--contrast">Tac</span> Toe</h1>
      <hr className="header__hr" />
    </div>
  )
}
